<template>
  <div/>
</template>

<script lang="ts">
import {Component, Prop, Vue, Watch} from 'vue-property-decorator';

/**
 * This component can be used to capture the event from the complete
 * window in you component
 */
@Component
export default class KeyCapture extends Vue {
  private static readonly KEY_EVENT = 'keydown';

  @Prop({default: false, type: Boolean})
  public enabled!: boolean;

  public mounted(): void {
    // We need to create the handler here in order to correctly bind the this context
    this.handler = (e) => {
      if (!this.enabled) {
        return;
      }

      this.$emit(KeyCapture.KEY_EVENT, e);
    };

    this.onEnabledChanged();
  }

  // noinspection JSUnusedGlobalSymbols Vue lifecycle
  public beforeDestroy(): void {
    this.unregister();
  }

  // noinspection UnterminatedStatementJS Because tslint
  private handler: (e: Event) => void = () => {
    // Empty default handler
  }

  @Watch('enabled')
  private onEnabledChanged(): void {
    if (this.enabled) {
      this.register();
    } else {
      this.unregister();
    }
  }

  private register(): void {
    window.addEventListener(KeyCapture.KEY_EVENT, this.handler);
  }

  private unregister(): void {
    window.removeEventListener(KeyCapture.KEY_EVENT, this.handler);
  }
}
</script>
